import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import APISERVICE from '../../services/api-service';

export default function LiveStreamSnapshot({ channelName, fallbackImage, onClick, width = 280, height = 157 }) {
  const [showClickOverlay, setShowClickOverlay] = useState(false);
  const [snapshotUrl, setSnapshotUrl] = useState(fallbackImage);
  const [isLoading, setIsLoading] = useState(true); // Start with loading true to use fallback initially
  
  useEffect(() => {
    const fetchSnapshot = async () => {
      if (!channelName) return;
      
      try {
        const response = await APISERVICE.get(`/snapshot/livestream/${channelName}/snapshot`);
        
        console.log(`[LiveStreamSnapshot] Full response for ${channelName}:`, response);
        
        let newSnapshotUrl = null;
        
        if (response?.result?.url) {
          newSnapshotUrl = response.result.url;
        } else if (response?.data?.result?.url) {
          newSnapshotUrl = response.data.result.url;
        } else if (response?.url) {
          newSnapshotUrl = response.url;
        }
        
        // Only update if we got a real snapshot URL (not a placeholder)
        if (newSnapshotUrl && !newSnapshotUrl.includes('placehold.co')) {
          setSnapshotUrl(newSnapshotUrl);
          setIsLoading(false);
          console.log(`[LiveStreamSnapshot] Snapshot updated for ${channelName}:`, newSnapshotUrl);
        } else {
          console.log(`[LiveStreamSnapshot] No valid snapshot URL in response for ${channelName}, keeping fallback`);
        }
      } catch (error) {
        console.log(`[LiveStreamSnapshot] Error fetching snapshot for ${channelName}:`, error.response?.data || error.message);
        
        // If we get a 404, the stream has likely ended
        if (error.response?.status === 404) {
          console.log(`[LiveStreamSnapshot] Stream appears to have ended for ${channelName}, using fallback`);
          setIsLoading(false);
          // Stop trying to fetch snapshots
          return;
        }
        // Keep using fallback image, don't change isLoading
      }
    };
    
    fetchSnapshot();
    
    // Refresh snapshot every 30 seconds if component is still mounted
    const interval = setInterval(fetchSnapshot, 30000);
    
    return () => clearInterval(interval);
  }, [channelName, fallbackImage]);

  return (
    <Box
      sx={{
        position: 'relative',
        width: `${width}px`,
        height: `${height}px`,
        borderRadius: '8px',
        overflow: 'hidden',
        cursor: 'pointer',
        backgroundColor: '#000',
        '&:hover': {
          transform: 'scale(1.05)',
          transition: 'all 0.3s ease',
        }
      }}
      onClick={onClick}
      onMouseEnter={() => setShowClickOverlay(true)}
      onMouseLeave={() => setShowClickOverlay(false)}
    >
      {/* Snapshot/Fallback image */}
      <Box
        sx={{
          width: '100%',
          height: '100%',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <img
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '8px',
            transition: 'opacity 0.3s ease-in-out',
            opacity: 1,
          }}
          src={snapshotUrl}
          alt=""
          onLoad={(e) => {
            // Ensure smooth transition when image loads
            e.target.style.opacity = '1';
          }}
        />
        
      </Box>



      {/* Viewer count (optional, if available) */}
      {/* <Box
        sx={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          backgroundColor: 'rgba(0,0,0,0.6)',
          color: 'white',
          padding: '2px 6px',
          borderRadius: '4px',
          fontSize: '11px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        }}
      >
        <Box sx={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#00ff00' }} />
        123
      </Box> */}

      {/* Click to watch overlay */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0) 100%)',
          padding: '20px 10px 10px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          opacity: showClickOverlay ? 1 : 0,
          transition: 'opacity 0.3s ease',
        }}
      >
        <Typography
          sx={{
            color: 'white',
            fontSize: '13px',
            fontWeight: 'bold',
            textAlign: 'center',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
          }}
        >
          ▶ Watch Live
        </Typography>
      </Box>
    </Box>
  );
}